import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createRestaurant } from '../../store/actions/restaurantActions'
import { Redirect, NavLink } from 'react-router-dom'
import { tagFunctions } from './Tags'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import Creatable from 'react-select/creatable'
import Select from 'react-select/'
import { iconSwitch } from './IconSwitch'
import Checkbox from '../layout/CheckboxBlack'

class CreateRestaurant extends Component {

  constructor(props) {
  super(props);
  this.state = {
    name: '',
    url: '',
    phoneNumber: '',
    orderUrl: '',
    menuUrl: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    hours: '',
    content: '',
    tags: '',
    primaryTag:'',
    iconImage:'',
    iconSize: 60,
    iconPadding: '20%',
    location: '',
    pickupOnly: false,
    
    splitHours:false,
    sunAM: 'AM',
    sunPM: 'PM',
    sundayAM: '',
    sundayPM: '',

    sunAM2: 'AM',
    sunPM2: 'PM',
    sundayAM2: '',
    sundayPM2: '',
    
    monAM: 'AM',
    monPM: 'PM',
    mondayAM: '',
    mondayPM: '',

    monAM2: 'AM',
    monPM2: 'PM',
    mondayAM2: '',
    mondayPM2: '',

    tueAM: 'AM',
    tuePM: 'PM',
    tuesdayAM: '',
    tuesdayPM: '',

    tueAM2: 'AM',
    tuePM2: 'PM',
    tuesdayAM2: '',
    tuesdayPM2: '',

    wedAM: 'AM',
    wedPM: 'PM',
    wednesdayAM: '',
    wednesdayPM: '',

    wedAM2: 'AM',
    wedPM2: 'PM',
    wednesdayAM2: '',
    wednesdayPM2: '',

    thuAM: 'AM',
    thuPM: 'PM',
    thursdayAM: '',
    thursdayPM: '',

    thuAM2: 'AM',
    thuPM2: 'PM',
    thursdayAM2: '',
    thursdayPM2: '',

    friAM: 'AM',
    friPM: 'PM',
    fridayAM: '',
    fridayPM: '',

    friAM2: 'AM',
    friPM2: 'PM',
    fridayAM2: '',
    fridayPM2: '',

    satAM: 'AM',
    satPM: 'PM',
    saturdayAM: '',
    saturdayPM: '',

    satAM2: 'AM',
    satPM2: 'PM',
    saturdayAM2: '',
    saturdayPM2: '',

    selection: '',
    userPoints: 0,
    match:false
  }
  }

  handleSelect = (selection) =>{
    var tags = [];
    var newSelection = [];
    if(selection){
      for(var tag in selection){
        if(selection[tag]['value'] !== this.state.primaryTag){
          newSelection.push(selection[tag])     
        }
      }
      tags = newSelection.map(mapTags);
      this.setState({ tags: tags, selection: newSelection });  
    }
    else{
      this.setState({ tags: '' });  
    }
  }

  handleSuggest = (selection) =>{
    this.setState({tags:[...this.state.tags, selection[0]['value']],
     selection:[...this.state.selection, selection[0]],
     suggestion:""})
  }

  componentDidMount(){
    if(this.props.points && this.props.auth && this.props.points[this.props.auth.uid]){
      var userPoints = 0;
      for(var point in this.props.points[this.props.auth.uid]){
        userPoints = userPoints + this.props.points[this.props.auth.uid][point];
      }
      if(this.state.userPoints !== userPoints){
        this.setState({userPoints:userPoints})
      }
    }

    if(this.state.iconImage === ''){
        iconSwitch(this.state.primaryTag, this);
      }
  }

  componentDidUpdate(props){
    
    if(this.props.restaurants && ((this.state.tags.length > 0 && this.state.primaryTag !== "") || (this.state.primaryTag === "" && this.state.tags.length > 1))){
      var allTags = [];
      if(this.state.primaryTag !== ""){
        allTags.push(this.state.primaryTag)  
      }
      for(var tag in this.state.tags){
        allTags.push(this.state.tags[tag]);  
      }
      var similarTagIdList = [];
      for(var restaurant in this.props.restaurants){
        var allTags2 = [];
        if(this.state.primaryTag !== ""){
          allTags2.push(this.props.restaurants[restaurant].primaryTag)  
        }
        for(var tag in this.props.restaurants[restaurant].tags){
          allTags2.push(this.props.restaurants[restaurant].tags[tag]);  
        }

        const filteredArray = allTags.filter(value => allTags2.includes(value));
        if(filteredArray.length > 1){
          similarTagIdList.push(this.props.restaurants[restaurant].restaurantId);
        }
      }
      var similarRestaurants = [];
      similarRestaurants = this.props.restaurants.filter(restaurant => similarTagIdList.includes(restaurant.restaurantId));
      var similarTagList = tagFunctions.compileTags(similarRestaurants);
      var similarTagList2 = [];
      for(var tag in similarTagList){
        if(!allTags.includes(similarTagList[tag].value)){
          similarTagList2.push(similarTagList[tag].value)
        }
      }
      var similarTagList3 = [];
      for(var tag in similarTagList2){
        similarTagList3.push({"value":similarTagList2[tag],"label":similarTagList2[tag]})
      }
      if(similarTagList3.length > 0 && JSON.stringify(this.state.suggestedTags) !== JSON.stringify(similarTagList3)){
        this.setState({suggestedTags:similarTagList3});
      }  
      else if(similarTagList3.length === 0 && this.state.suggestedTags !== false){
        this.setState({suggestedTags:false})
      }
    }

    if(this.props.points && this.props.auth && this.props.points[this.props.auth.uid]){
      var userPoints = 0;
      for(var point in this.props.points[this.props.auth.uid]){
        userPoints = userPoints + this.props.points[this.props.auth.uid][point];
      }
      if(this.state.userPoints !== userPoints){
        this.setState({userPoints:userPoints})
      }
    }

    if(this.state.iconImage === ''){
        iconSwitch(this.state.primaryTag, this);
      }
  }

  handlePrimaryTag = (selection) =>{
    if(selection){
    this.setState({ primaryTag: selection.value , iconImage: '' });  
    }
    else{
      this.setState({ primaryTag: '' , iconImage: ''});  
     }
  }    

  
  onFocus = (event) => {
   if(event.target.autocomplete){
     event.target.autocomplete = "off";
   }
  }

  onBlur = (e) => {
    if (!e.target.value.includes(':')){
      var x = e.target.value.replace(/\D/g, '');
      var y = '';
      if (x.length === 1){
        y = (x[0]+':00')
      }
      else if (x.length === 2){
        if (x[0] === "0"){
          y = (x[1]+':00')  
        }
        else if (x[0] === "1" && (x[1] === "0" || x[1] === "1" || x[1] === "2")){
          y = (x[0]+x[1]+':00') 
        }
        else { 
          y = (x[0]+':'+x[1]+'0')
        }
      }
      else if (x.length === 3){
        if (x[0] === "0"){
          y = (x[1]+':'+x[2]+'0')  
        }
        else if (x[0] === "1" && (x[1] === "0" || x[1] === "1" || x[1] === "2")){
          y = (x[0]+x[1]+':'+x[2]+'0') 
        }
        else {
          y = (x[0]+':'+x[1]+x[2])
        }
      }
      else{
        if (x[0] === "0"){
          y = (x[1]+':'+x[2]+x[3])
        }
        else{
          y = (x[0]+x[1]+':'+x[2]+x[3])
        }
      }
    if(y!=='NaN:undefinedundefined'){
    e.target.value = y;

    this.setState({
      [e.target.id]: y
    });  
    }
  }
  }
  
  handleFill = (e) => {
    //console.log(e.target.id);
    var filler = [];
    switch(e.target.id){
      case "Sunday":
        if(this.state.sundayAM !== "" && this.state.sundayPM !== ""){
          filler = [this.state.sunAM,this.state.sunPM,this.state.sundayAM,this.state.sundayPM];  
        }
        break;
      case "Monday":
        if(this.state.mondayAM !== "" && this.state.mondayPM !== ""){
          filler = [this.state.monAM,this.state.monPM,this.state.mondayAM,this.state.mondayPM];  
        }
        break;
      case "Tuesday":
        if(this.state.tuesdayAM !== "" && this.state.tuesdayPM !== ""){
          filler = [this.state.tueAM,this.state.tuePM,this.state.tuesdayAM,this.state.tuesdayPM];  
        }
        break;
      case "Wednesday":
        if(this.state.wednesdayAM !== "" && this.state.wednesdayPM !== ""){
          filler = [this.state.wedAM,this.state.wedPM,this.state.wednesdayAM,this.state.wednesdayPM];  
        }
        break;
      case "Thursday":
        if(this.state.thursdayAM !== "" && this.state.thursdayPM !== ""){
          filler = [this.state.thuAM,this.state.thuPM,this.state.thursdayAM,this.state.thursdayPM];  
        }
        break;
      case "Friday":
        if(this.state.fridayAM !== "" && this.state.fridayPM !== ""){
          filler = [this.state.friAM,this.state.friPM,this.state.fridayAM,this.state.fridayPM];  
        }
        break;
      case "Saturday":
        if(this.state.saturdayAM !== "" && this.state.saturdayPM !== ""){
          filler = [this.state.satAM,this.state.satPM,this.state.saturdayAM,this.state.saturdayPM];  
        }
        break;
    }

    //console.log('filler');
    //console.log(filler);

    if(this.state.sundayAM === "" && this.state.sundayPM === ""){
      this.setState({
        sunAM: filler[0],
        sunPM: filler[1],
        sundayAM: filler[2],
        sundayPM: filler[3]
      })
    }
    if(this.state.mondayAM === "" && this.state.mondayPM === ""){
      this.setState({
        monAM: filler[0],
        monPM: filler[1],
        mondayAM: filler[2],
        mondayPM: filler[3]
      })
    }
    if(this.state.tuesdayAM === "" && this.state.tuesdayPM === ""){
      this.setState({
        tueAM: filler[0],
        tuePM: filler[1],
        tuesdayAM: filler[2],
        tuesdayPM: filler[3]
      })
    }
    if(this.state.wednesdayAM === "" && this.state.wednesdayPM === ""){
      this.setState({
        wedAM: filler[0],
        wedPM: filler[1],
        wednesdayAM: filler[2],
        wednesdayPM: filler[3]
      })
    }
    if(this.state.thursdayAM === "" && this.state.thursdayPM === ""){
      this.setState({
        thuAM: filler[0],
        thuPM: filler[1],
        thursdayAM: filler[2],
        thursdayPM: filler[3]
      })
    }
    if(this.state.fridayAM === "" && this.state.fridayPM === ""){
      this.setState({
        friAM: filler[0],
        friPM: filler[1],
        fridayAM: filler[2],
        fridayPM: filler[3]
      })
    }
    if(this.state.saturdayAM === "" && this.state.saturdayPM === ""){
      this.setState({
        satAM: filler[0],
        satPM: filler[1],
        saturdayAM: filler[2],
        saturdayPM: filler[3]
      })
    }

  }

  handleChange = (e) => {
    if (e.target.id==='phoneNumber'){
      var z = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      //console.log(z);
      e.target.value = !z[2] ? z[1] : '(' + z[1] + ') ' + z[2] + (z[3] ? '-' + z[3] : '');
    }
    else if (e.target.id==='orderUrl' && this.state.menuUrl !== ''){
      e.target.value = '';
    }
    else if (e.target.id==='menuUrl' && this.state.orderUrl !== ''){
      e.target.value = '';
    }

    // if target id includes string 'day'
    // regex for time format with grayed out autofill
    else if (e.target.id.includes('day')){
      //console.log('change')
      var x = e.target.value.replace(/\D/g, '');
      var y = '';
      //console.log(x);
      //console.log(x.length);
      //console.log(x[0]);
      //console.log(x[1]);
      if (x.length === 1){
        y = (x[0]+':00')
      }
      else if (x.length === 2){
        if (x[0] === "0"){
          y = (x[1]+':00')  
        }
        else if (x[0] === "1" && (x[1] === "0" || x[1] === "1" || x[1] === "2")){
          //console.log('true');
          y = (x[0]+x[1]+':00') 
        }
        else { 
          y = (x[0]+':'+x[1]+'0')
        }
      }
      else if (x.length === 3){
        if (x[0] === "0"){
          y = (x[1]+':'+x[2]+'0')  
        }
        else if (x[0] === "1" && (x[1] === "0" || x[1] === "1" || x[1] === "2")){
          y = (x[0]+x[1]+':'+x[2]+'0') 
        }
        else {
          y = (x[0]+':'+x[1]+x[2])
        }
      }
      else{
        if (x[0] === "0"){
          y = (x[1]+':'+x[2]+x[3])
        }
        else{
          y = (x[0]+x[1]+':'+x[2]+x[3])
        }
      }  
      //console.log(y)


    }


    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  handleCheck = (e) => {
   this.setState({
    [e.target.id]: e.target.checked
   })
 }

  preventSubmit = (e) =>{
    e.preventDefault();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // //console.log(this.state);
    //console.log('submitted');

    var submitHours = [];
    if(this.state.splitHours){
      //console.log('split hours submit');
      submitHours = [
    this.state.sundayAM + ' ' + this.state.sunAM + ' - ' + this.state.sundayPM + ' ' + this.state.sunPM, 
    this.state.sundayAM2 + ' ' + this.state.sunAM2 + ' - ' + this.state.sundayPM2 + ' ' + this.state.sunPM2,
    this.state.mondayAM + ' ' + this.state.monAM + ' - ' + this.state.mondayPM + ' ' + this.state.monPM,
    this.state.mondayAM2 + ' ' + this.state.monAM2 + ' - ' + this.state.mondayPM2 + ' ' + this.state.monPM2,
    this.state.tuesdayAM + ' ' + this.state.tueAM + ' - ' + this.state.tuesdayPM + ' ' + this.state.tuePM,
    this.state.tuesdayAM2 + ' ' + this.state.tueAM2 + ' - ' + this.state.tuesdayPM2 + ' ' + this.state.tuePM2,
    this.state.wednesdayAM + ' ' + this.state.wedAM + ' - ' + this.state.wednesdayPM + ' ' + this.state.wedPM,
    this.state.wednesdayAM2 + ' ' + this.state.wedAM2 + ' - ' + this.state.wednesdayPM2 + ' ' + this.state.wedPM2,
    this.state.thursdayAM + ' ' + this.state.thuAM + ' - ' + this.state.thursdayPM + ' ' + this.state.thuPM,
    this.state.thursdayAM2 + ' ' + this.state.thuAM2 + ' - ' + this.state.thursdayPM2 + ' ' + this.state.thuPM2,
    this.state.fridayAM + ' ' + this.state.friAM + ' - ' + this.state.fridayPM + ' ' + this.state.friPM,
    this.state.fridayAM2 + ' ' + this.state.friAM2 + ' - ' + this.state.fridayPM2 + ' ' + this.state.friPM2,
    this.state.saturdayAM + ' ' + this.state.satAM + ' - ' + this.state.saturdayPM + ' ' + this.state.satPM,
    this.state.saturdayAM2 + ' ' + this.state.satAM2 + ' - ' + this.state.saturdayPM2 + ' ' + this.state.satPM2
    ]
    }
    else if(!this.state.splitHours){
      //console.log('not split hours submit');
      submitHours = [
    this.state.sundayAM + ' ' + this.state.sunAM + ' - ' + this.state.sundayPM + ' ' + this.state.sunPM, 
    this.state.mondayAM + ' ' + this.state.monAM + ' - ' + this.state.mondayPM + ' ' + this.state.monPM,
    this.state.tuesdayAM + ' ' + this.state.tueAM + ' - ' + this.state.tuesdayPM + ' ' + this.state.tuePM,
    this.state.wednesdayAM + ' ' + this.state.wedAM + ' - ' + this.state.wednesdayPM + ' ' + this.state.wedPM,
    this.state.thursdayAM + ' ' + this.state.thuAM + ' - ' + this.state.thursdayPM + ' ' + this.state.thuPM,
    this.state.fridayAM + ' ' + this.state.friAM + ' - ' + this.state.fridayPM + ' ' + this.state.friPM,
    this.state.saturdayAM + ' ' + this.state.satAM + ' - ' + this.state.saturdayPM + ' ' + this.state.satPM
    ]
    }

    this.setState({
      submitted: true,
      hours:submitHours
    },()=>this.props.createRestaurant({    
    name: this.state.name,
    url: this.state.url,
    phoneNumber: this.state.phoneNumber,
    orderUrl: this.state.orderUrl,
    menuUrl: this.state.menuUrl,
    address: this.state.address,
    city: this.state.city,
    state: this.state.state,
    zip: this.state.zip,
    hours: this.state.hours,
    content: this.state.content,
    primaryTag: this.state.primaryTag,
    tags: this.state.tags,
    location: this.state.location,
    pickupOnly: this.state.pickupOnly,

    splitHours: this.state.splitHours,
    sunAM: this.state.sunAM,
    sunPM: this.state.sunPM,
    sundayAM: this.state.sundayAM,
    sundayPM: this.state.sundayPM,

    sunAM2: this.state.sunAM2,
    sunPM2: this.state.sunPM2,
    sundayAM2: this.state.sundayAM2,
    sundayPM2: this.state.sundayPM2,
    
    monAM: this.state.monAM,
    monPM: this.state.monPM,
    mondayAM: this.state.mondayAM,
    mondayPM: this.state.mondayPM,

    monAM2: this.state.monAM2,
    monPM2: this.state.monPM2,
    mondayAM2: this.state.mondayAM2,
    mondayPM2: this.state.mondayPM2,

    tueAM: this.state.tueAM,
    tuePM: this.state.tuePM,
    tuesdayAM: this.state.tuesdayAM,
    tuesdayPM: this.state.tuesdayPM,

    tueAM2: this.state.tueAM2,
    tuePM2: this.state.tuePM2,
    tuesdayAM2: this.state.tuesdayAM2,
    tuesdayPM2: this.state.tuesdayPM2,

    wedAM: this.state.wedAM,
    wedPM: this.state.wedPM,
    wednesdayAM: this.state.wednesdayAM,
    wednesdayPM: this.state.wednesdayPM,

    wedAM2: this.state.wedAM2,
    wedPM2: this.state.wedPM2,
    wednesdayAM2: this.state.wednesdayAM2,
    wednesdayPM2: this.state.wednesdayPM2,

    thuAM: this.state.thuAM,
    thuPM: this.state.thuPM,
    thursdayAM: this.state.thursdayAM,
    thursdayPM: this.state.thursdayPM,

    thuAM2: this.state.thuAM2,
    thuPM2: this.state.thuPM2,
    thursdayAM2: this.state.thursdayAM2,
    thursdayPM2: this.state.thursdayPM2,

    friAM: this.state.friAM,
    friPM: this.state.friPM,
    fridayAM: this.state.fridayAM,
    fridayPM: this.state.fridayPM,

    friAM2: this.state.friAM2,
    friPM2: this.state.friPM2,
    fridayAM2: this.state.fridayAM2,
    fridayPM2: this.state.fridayPM2,

    satAM: this.state.satAM,
    satPM: this.state.satPM,
    saturdayAM: this.state.saturdayAM,
    saturdayPM: this.state.saturdayPM,

    satAM2: this.state.satAM2,
    satPM2: this.state.satPM2,
    saturdayAM2: this.state.saturdayAM2,
    saturdayPM2: this.state.saturdayPM2

    }, this.state.key, ()=>{this.props.history.push('/')}));
  }

  handleSplitHours =(e)=>{
    //console.log("split hours");
    this.setState({
      splitHours:!this.state.splitHours
    })
  }

  submitInterruptor =(e)=>{
    document.getElementById("myModal").style.display = "block";

    for(var pend in this.props.pendingCreate){
      if(!this.state.match && this.props.pendingCreate[pend]['name'] === this.state.name){
        this.setState({match:true});
      }
    }

    if(this.state.url !== ""){
      if(this.state.url.slice(0,8) === 'https://'){
        this.setState({
          url:this.state.url.slice(8)
        })
      }
      if(this.state.url.slice(0,7) === 'http://'){
        this.setState({
          url:this.state.url.slice(7)
        })
      }
    }

    if(this.state.orderUrl !== ""){
      if(this.state.orderUrl.slice(0,8) === 'https://'){
        this.setState({
          orderUrl:this.state.orderUrl.slice(8)
        })
      }
      if(this.state.orderUrl.slice(0,7) === 'http://'){
        this.setState({
          orderUrl:this.state.orderUrl.slice(7)
        })
      }
    }

    if(this.state.menuUrl !== ""){
      if(this.state.menuUrl.slice(0,8) === 'https://'){
        this.setState({
          menuUrl:this.state.menuUrl.slice(8)
        })
      }
      if(this.state.menuUrl.slice(0,7) === 'http://'){
        this.setState({
          menuUrl:this.state.menuUrl.slice(7)
        })
      }
    }

    if(this.state.state !== '' && this.state.zip !== '' && this.state.city !== '' && this.state.address !== '' ){
      
      var newAddress = this.state.address;
      var newState = this.state.state;
      var newCity = this.state.city;
      var newZip = this.state.zip;

      var itemArray = [newAddress, newState, newCity, newZip];
      var shouldTest = [true,true,true,true];
      var falseTest = [false,false,false,false];

      while(JSON.stringify(shouldTest) != JSON.stringify(falseTest)){
        for(var item in itemArray){
          if(shouldTest[item]){ 
            if(itemArray[item].charAt(itemArray[item].length-1)=='.' ||
              itemArray[item].charAt(itemArray[item].length-1)==' ' ||
              itemArray[item].charAt(itemArray[item].length-1)==','
              ){
              itemArray[item] = itemArray[item].slice(0,-1);
            }
            else{
              shouldTest[item] = false;
            }
          }
        }  
      }

      this.calculateLocation(itemArray[1], itemArray[3], itemArray[2], itemArray[0]);
      //console.log('location');
      //console.log(this.state.location);
    }
    
  }
  closeFunction =(e)=>{
    if(this.state.match){
          this.setState({match:false})
    }
    document.getElementById("myModal").style.display = "none";
  }

  calculateLocation = (state, zip, city, address) => {

    const Http = new XMLHttpRequest();
    const addressEncoded = encodeURIComponent(address);

    const url='https://dev.virtualearth.net/REST/v1/Locations/US/'+state+'/'+zip+'/'+city+'/'+addressEncoded+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';
    //console.log('url');
    //console.log(url);

    Http.open("GET", url);
    Http.send();
    const that = this;

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
        var parsedJSON = JSON.parse(Http.responseText);
        //console.log(parsedJSON);
        that.setState({httpResponse:parsedJSON})
        if(that.state.httpResponse !== ''){
          //console.log('coordinates');
          //console.log(that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates);
          that.setState({location: that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates});
          that.setState({route:''});
        }
      }
      //else{console.log('notready')}
    }

   // restaurants.map(restaurant=>{
   //  return(console.log(restaurant.address))
   // })
  }


  render() {
    const { auth, user, restaurants, pendingCreate, points } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />
    
    if(restaurants){
      var tagsList = tagFunctions.compileTags(restaurants);
      var options = tagsList;
    }

    window.onclick = function(event) {
      if (event.target === document.getElementById("myModal")) {
        if(this.state.match){
          this.setState({match:false})
        }
        document.getElementById("myModal").style.display = "none";
        }
      }
    

    return (
      <div>
      { auth && user && restaurants && pendingCreate && points && (pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid).length < 10 || this.state.userPoints > 9 ) 
        && (pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid).length < 1 || user.firstName !== "Guest" ) &&
            <div className="signInContainer">
            <div id="myModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunction}>&times;</span>
                <p>Are you sure you want to submit?</p>
                { !this.state.match && !this.state.submitted &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleSubmit}>Submit</button>
                </div>
                }
                { this.state.match &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <p>You have a pending restaurant with the same name.</p>
                </div>
                }
            </div>
    
            </div>
            <form className="formContainer" autoComplete="off" onSubmit={this.preventSubmit}>
              <h5 className="grey-text text-darken-3" style={{"display":"flex", "justifyContent":"center"}}>Add a Restaurant</h5>
              <div className="input-field">
                <input type="text" id='name' name='name' autoComplete="new-password" onChange={this.handleChange} />
                <label htmlFor="title">Restaurant Name</label>
              </div>
              <div className="input-field">
                <input type="text" id='address' name='address' onChange={this.handleChange} />
                <label htmlFor="title">Address</label>
              </div>
              <div className="input-field">
                <label htmlFor="city">City</label>
                <input type="text" id='city' onChange={this.handleChange} />
              </div>
              <div className="input-field">
                <label htmlFor="state">State</label>
                <input type="text" id='state' onChange={this.handleChange} />
              </div>
              <div className="input-field">
                <label htmlFor="zip">Zip</label>
                <input type="text" id='zip' onChange={this.handleChange} />
              </div>
    
              <div className="input-field">
                <input type="text" id='phoneNumber'  onFocus={this.onFocus} onChange={this.handleChange} />
                <label htmlFor="title">Phone Number</label>
              </div>
              <div className="input-field">
                <input type="text" id='url' onChange={this.handleChange} />
                <label htmlFor="title">Link to Website</label>
              </div>
              <div className="input-field">
                <input type="text" id='orderUrl' onChange={this.handleChange} />
                <label htmlFor="title">Link to Order Online</label>
              </div>
              <div className="input-field">
                <input type="text" id='menuUrl' onChange={this.handleChange} />
                <label htmlFor="title">Link to Menu</label>
              </div>
    
              <Checkbox label = 'Pickup Only' id='pickupOnly' isSelected={this.state.pickupOnly} onCheckboxChange = {this.handleCheck} />
    
              <div className="grey-text text-darken-3" style={{"display":"flex", "justifyContent":"center"}}>
                <span > Tags </span>
              </div>
              <div className='tagIcon' style={{"display":"flex","justifyContent":"center","paddingTop":"5px"}}><img alt="Tag Icon" height={this.state.iconSize} src={this.state.iconImage}/></div>
              <span style={{"fontSize":"12px"}}>Primary Tag</span>
              <Creatable options={options} onChange={this.handlePrimaryTag}/>            
              
              <span style={{"fontSize":"12px"}}>Additional Tags</span>
              <Creatable isMulti options={options} value={this.state.selection} onChange={this.handleSelect}/>
              
              { this.state.suggestedTags && 
              <div>
                <span style={{"fontSize":"12px"}}>Suggested Tags</span>
                <Select isMulti options={this.state.suggestedTags} value={this.state.suggestion} onChange={this.handleSuggest}/>
              </div>
              }

              <div className="grey-text text-darken-3" style={{"display":"flex", "justifyContent":"center"}}>
                <span > Hours </span>
              </div>

              {
                <div style={{"display":"flex", "justifyContent":"center"}}>
                  <button type="button" className="btn pink lighten-1" onClick={this.handleSplitHours}>Split Hours</button>
                </div>
              }

              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Sunday</span>
                <span id="Sunday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='sundayAM' value={this.state.sundayAM} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='sunAM' style={{width:'50px'}} className='browser-default' value={this.state.sunAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='sundayPM' value={this.state.sundayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='sunPM' style={{width:'50px'}} className='browser-default' value={this.state.sunPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='sundayAM2' value={this.state.sundayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='sunAM2' style={{width:'50px'}} className='browser-default' value={this.state.sunAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='sundayPM2' value={this.state.sundayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='sunPM2' style={{width:'50px'}} className='browser-default' value={this.state.sunPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
              
              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Monday</span>
                <span id="Monday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='mondayAM' value={this.state.mondayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='monAM' style={{width:'50px'}} className='browser-default' value={this.state.monAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='mondayPM' value={this.state.mondayPM} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='monPM' style={{width:'50px'}} className='browser-default' value={this.state.monPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='mondayAM2' value={this.state.mondayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='monAM2' style={{width:'50px'}} className='browser-default' value={this.state.monAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='mondayPM2' value={this.state.mondayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='monPM2' style={{width:'50px'}} className='browser-default' value={this.state.monPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
    
              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Tuesday</span>
                <span id="Tuesday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='tuesdayAM' value={this.state.tuesdayAM} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='tueAM' style={{width:'50px'}} className='browser-default' value={this.state.tueAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='tuesdayPM' value={this.state.tuesdayPM} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='tuePM' style={{width:'50px'}} className='browser-default' value={this.state.tuePM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='tuesdayAM2' value={this.state.tuesdayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='tueAM2' style={{width:'50px'}} className='browser-default' value={this.state.tueAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='tuesdayPM2' value={this.state.tuesdayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='tuePM2' style={{width:'50px'}} className='browser-default' value={this.state.monPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
    
              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Wednesday</span>
                <span id="Wednesday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='wednesdayAM' value={this.state.wednesdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='wedAM' style={{width:'50px'}} className='browser-default' value={this.state.wedAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='wednesdayPM' value={this.state.wednesdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='wedPM' style={{width:'50px'}} className='browser-default' value={this.state.wedPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>
    
            { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='wednesdayAM2' value={this.state.wednesdayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='wedAM2' style={{width:'50px'}} className='browser-default' value={this.state.wedAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='wednesdayPM2' value={this.state.wednesdayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='wedPM2' style={{width:'50px'}} className='browser-default' value={this.state.wedPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }

              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Thursday</span>
                <span id="Thursday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='thursdayAM' value={this.state.thursdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='thuAM' style={{width:'50px'}} className='browser-default' value={this.state.thuAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='thursdayPM' value={this.state.thursdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='thuPM' style={{width:'50px'}} className='browser-default' value={this.state.thuPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='thursdayAM2' value={this.state.thursdayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='thuAM2' style={{width:'50px'}} className='browser-default' value={this.state.thuAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='thursdayPM2' value={this.state.thursdayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='thuPM2' style={{width:'50px'}} className='browser-default' value={this.state.thuPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
    
              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Friday</span>
                <span id="Friday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='fridayAM' value={this.state.fridayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='friAM' style={{width:'50px'}} className='browser-default' value={this.state.friAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='fridayPM' value={this.state.fridayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='friPM' style={{width:'50px'}} className='browser-default' value={this.state.friPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='fridayAM2' value={this.state.fridayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='friAM2' style={{width:'50px'}} className='browser-default' value={this.state.friAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='fridayPM2' value={this.state.fridayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='friPM2' style={{width:'50px'}} className='browser-default' value={this.state.friPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
    
              <div style={{"display":"flex", "justifyContent":"space-between"}}>
                <span style={{"fontSize":"12px"}}>Saturday</span>
                <span id="Saturday" style={{"fontSize":"12px", marginRight:"50px", color:"blue"}} onClick={this.handleFill}>Fill Others</span>
              </div>
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='saturdayAM' value={this.state.saturdayAM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='satAM' style={{width:'50px'}} className='browser-default' value={this.state.satAM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='saturdayPM' value={this.state.saturdayPM} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='satPM' style={{width:'50px'}} className='browser-default' value={this.state.satPM} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>

              { this.state.splitHours &&
              <div>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='saturdayAM2' value={this.state.saturdayAM2} onChange={this.handleChange} onBlur={this.onBlur} />
                </label>
                <label className='input-row'>
                  <select id='satAM2' style={{width:'50px'}} className='browser-default' value={this.state.satAM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
                <label className='input-row'>
                  <input style={{width:'50px'}} type="text" id='saturdayPM2' value={this.state.saturdayPM2} onChange={this.handleChange} onBlur={this.onBlur}/>
                </label>
                <label className='input-row'>
                  <select id='satPM2' style={{width:'50px'}} className='browser-default' value={this.state.satPM2} onChange={this.handleChange}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </label>
              </div>                
              }
              
              <div className="input-field" style={{"display":"flex", "justifyContent":"center"}}>
                <button type="submit" className="btn pink lighten-1" onClick={this.submitInterruptor}>Create</button>
              </div>
            </form>
          </div>
        }
        {
        auth && user && restaurants && pendingCreate && points && pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid).length > 9 && this.state.userPoints < 10 && 
        <div style={{textAlign:"center"}}>
        <br/><br/><br/>
        <h3>You may not add restaurants at this time.</h3>
        <p> Please wait until your current pending submissions are approved. </p>
        <p> Your limit on pending submissions will be raised when you are awarded points.</p>
        <p> You can delete pending submissions on your user page. </p>
        <NavLink to='/about/points' >About the point system</NavLink>
        </div> 
        }
        {
        auth && user && restaurants && pendingCreate && points && pendingCreate.filter(restaurant=>restaurant.authorId === auth.uid).length > 0 && this.state.userPoints < 10 
        && user.firstName === "Guest" &&
        <div style={{textAlign:"center"}}>
        <br/><br/><br/>
        <h3>You may not add restaurants at this time.</h3>
        <p> Guests are limited to one pending restaurant.</p>
        <p> Please wait until your current pending submissions are approved. </p>
        <p> You can delete pending submissions on your user page. </p>
        <NavLink to='/about/points' >About the point system</NavLink>
        </div> 
        }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurants: state.firestore.ordered.restaurants,
    pendingCreate: state.firestore.ordered.pendingCreate,
    points: state.firestore.data.points,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createRestaurant: (project, id, callback) => dispatch(createRestaurant(project, id, callback))
  }
}

const mapTags = (tags) =>{
  return(tags['value'])
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  firestoreConnect(props =>{
    const userId = props.auth.uid
    if(!userId){
      return []
    }
    return[
    { collection: 'restaurants' },
    { collection: 'pendingCreate', where: [['authorId', '==', props.auth.uid]] },
    { collection: 'points' }
  ]})
)(CreateRestaurant)

